import { ExpandableInputField } from "@motley/design"
import type { ComponentProps } from "react"
import FormControl from "./FormControl"

export type Props = ComponentProps<typeof ExpandableInputField> & {
  name: string
  emptyAsString?: boolean
}

export default function FormExpandableInput({
  name,
  required,
  emptyAsString,
  onChange,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required={required} emptyAsString={emptyAsString}>
      {({ field, isError, error }) => (
        <ExpandableInputField
          id={name}
          required={required}
          aria-invalid={isError}
          error={error}
          {...field}
          name={name}
          {...rest}
          onChange={(e) => {
            field.onChange(e)
            onChange?.(e)
          }}
        />
      )}
    </FormControl>
  )
}
